<template>
  <div v-if="$route.path !== '/livevideo'">
    <div class="md-nav-welcome" v-if="isLogin">
      <p>
        欢迎
        {{
          userInfo
            ? userInfo?.dept?.deptName || userInfo.deptName
            : deptNameinfo
        }}
      </p>
      <!-- <p>123123</p> -->
    </div>
    <header
      v-if="!$store.state.specialRouters.includes($route.path)"
      class="md-shared-header"
      :class="[$store.state.fixed ? 'md-shared-header-fixed' : '']"
      @click="isShowSearchBox = false"
      :style="{ top: isLogin ? '30px' : '0px' }"
    >
      <div class="md-nav-box">
        <div class="md-nav-panel">
          <img
            v-if="userInfo && userInfo.dept.deptId === 269"
            src="@/assets/img/logo1.png"
            @click="handleNav({ path: '/home' })"
            alt=""
          />
          <img
            v-else
            src="@/assets/img/icon.png"
            @click="handleNav({ path: '/home' })"
            alt=""
          />
          <ul class="class-list">
            <li
              class="class-item"
              v-for="(item, index) in navList"
              :key="index"
              @click="handleNav(item)"
            >
              <span :class="$route.path === item.path ? 'active' : ''">{{
                item.name
              }}</span>
              <img v-show="$route.path === item.path"  style="width: 44px;height: 10px;position: absolute; bottom: -10px;"  src="../assets/img/text-under.png" alt="">
            </li>
            <!-- 只有首页展示 -->
          </ul>
          <div class="search-box" style="margin-left: 270px">
            <el-input
              placeholder="请输入关键字..."
              class="search-input"
              v-model="searchVal"
            >
              <i slot="suffix" class="el-icon-search" @click="handleSearch">
              </i>
            </el-input>
          </div>
          <!-- <div class="down-img" @click="goDownload" v-if="$route.path !== '/download'">
            <el-tooltip class="item" effect="dark" content="下载app" placement="bottom">
              <img src="@/assets/img/appdownload/download.png" alt="">
            </el-tooltip>

          </div> -->
        </div>
        <div class="nav-left">
          <!-- <i class="el-icon-search" v-show="!isShowSearchBox && $route.path !== '/home'"
            @click.stop="isShowSearchBox = true"></i>
          <div class="search-box" v-show="isShowSearchBox" @click.stop="isShowSearchBox = true">
            <el-input class="search-input" v-model="searchVal">
              <text slot="suffix" class="el-icon-search" @click="handleSearch"> 搜索</text>
            </el-input>
          </div> -->
          <MdNavClassComponent />
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { getConfigType } from "@/axios/home";
import MdNavClassComponent from "../components/class/mdNav/index.vue";
export default {
  name: "MdSharedHeaderComponent",
  components: {
    MdNavClassComponent,
  },
  data() {
    return {
      logo: "",
      deptName: "",
      user: null,
      isShowSearchBox: false,
      searchVal: "",
      navList: [
        {
          name: "首页",
          path: "/home",
        },
        {
          name: "东盟课程",
          path: "/category",
        },
        {
          name: "东盟题库",
          path: "/topics",
        },
        {
          name: "东盟资讯",
          path: "/news",
        },

        // {
        //   name: "东盟直播",
        //   path: "/live",
        // },
        {
          name: "",
          path: "",
        },
        {
          name: "",
          path: "",
        },
      ],
      isLogin:false,
    };
  },
  computed: {
  
    userInfo() {
      return JSON.parse(window.localStorage.getItem("userInfo"));
    },
    deptNameinfo() {
      return window.localStorage.getItem("deptName");
    },
  },
  watch: {
    "$store.state.user.dept": {
      handler(val) {
        this.deptName = val.deptName;
      },
    },
  },
  mounted() {
    this.user = this.$local.getItem("user");
    this.handleListenerScroll();
    this.getConfigType();
    this.isLogin = window.localStorage.getItem("isLogin");
    window.addEventListener("setItemEvent", (e) => {
      console.log(e.key,'key123');
      if (e.key == "isLogin") {
       
        this.isLogin = e.newValue;
      }
    });
  },
  beforeDestroy() {
    this.isShowSearchBox = false;
  },
  methods: {
    // logo
    async getConfigType() {
      const res = await getConfigType("web:logo");
      if (res.code === 200) {
        this.logo = res.msg;
      }
    },
    goDownload() {
      this.$router.push({
        path: "download",
      });
    },
    handleSearch() {
      if (this.isLogin) {
        if (!this.searchVal) {
          this.$message.error("请输入关键字");
          return;
        }
        if (this.$route.path === "/encyclopedia") {
          window.open(
            `http://academic.eb.cnpeak.com/levels/collegiate/search/articles?query=${this.searchVal}`,
            "_blank"
          );
        } else {
          this.$router.push({
            path: "/category",
            query: {
              searchValue: this.searchVal,
            },
          });
        }
        this.searchVal = "";
      } else {
        this.$confirm("是否去登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push({
              path: "/login",
            });
          })
          .catch(() => {});
      }
    },
    handleNav(item) {
      // 酷学题库、酷学资讯 新开页面
      if (["/topics"].includes(item.path)) {
        window.open(item.path);
      } else {
        this.$router.push({
          path: item.path,
        });
      }
    },
    handleGoHome() {
      window.open("/");
    },
    handleListenerScroll() {
      window.addEventListener("scroll", () => {
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        this.$store.state.fixed = scrollTop > 80;
        if (["/login"].includes(this.$route.path)) {
          this.$store.state.fixed = true;
        }
      });
    },
    handleCreateActivity() {
      if (!this.user) {
        this.$router.push("/login");
      } else {
        this.$router.push("/manage/home");
      }
    },
    handleMouseover(index) {
      this.subMenusIndex = index;
    },
    handleSubMenuClick(item) {
      this.$router.push(item.url);
    },
  },
};
</script>

<style lang="less" scoped>
.md-nav-welcome {
  background-color: #f5f5f5;
  width: 100%;

  p {
    width: 1152px;
    font-size: 14px;
    line-height: 20px;
    padding: 5px;
    margin: 0 auto;
    color: black;
  }
}

.md-shared-header {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  height: @md-header-height;
  background: #f0e4d3;
  box-shadow: 0px 2px 10px 0px rgba(117, 128, 126, 0.06);
  box-sizing: border-box;
  z-index: 998;
  display: flex;
  padding: 10px 0;
  align-items: center;

  &.md-shared-header-fixed {
    // background-color: #fff !important;
    box-shadow: 0 6px 10px 0 rgb(0 0 0 / 2%) !important;
  }

  .md-nav-box {
    min-width: 1200px;
    height: @md-header-height;
    margin: 0 auto;
    display: flex;
    align-items: center;
    // justify-content: space-between;

    .md-nav-panel {
      display: flex;
      align-items: center;

      img {
        cursor: pointer;
        width: 52px;
        height: 58px;
      }

      .class-list {
        display: flex;
        align-items: center;
        min-width: 500px;

        .class-item {
          margin-left: 30px;
          white-space: nowrap;
          position: relative;
          img{
            left: 50%; /* 将元素的左边缘移动到父元素的中心 */  
  transform: translateX(-50%); /* 将元素自身的中心与父元素的中心对齐 */ 
          }
          &:first-child {
            span {
              padding-left: 0;
            }
          }

          &:last-child {
            span {
              padding-right: 0;
            }
          }
          span {
            cursor: pointer;
            display: block;
            font-size: 16px;
            color: #d6a456;
            position: relative;
            &:hover {
              color: @md-primary-color;
            }
          }
          .active {
            color: @md-primary-color;
            font-weight: 600;
          }
        }
      }
    }

    .down-img {
      margin-left: 16px;
      width: 32px;
      height: 32px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .nav-left {
      height: 100%;
      font-size: 16px;
      color: rgba(15, 173, 152, 1);
      display: flex;
      align-items: center;
      // margin: 0 20px;
      margin-left: 18px;

      i {
        font-weight: bold;
        cursor: pointer;

        &:hover {
          color: @md-primary-color;
        }
      }
    }
  }
}

.search-box {
  /deep/ .search-input {
    .el-input__inner {
      border: none;
      width: 240px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 18px;
      border: 1px solid #cd9640;
      height: 36px;
    }

    .el-input__suffix {
      i {
        margin-top: 10px;
        margin-right: 3px;
        font-size: 16px;
        font-weight: bold;
        color: #cc9031;
        cursor: pointer;

        &:hover {
          color: @md-primary-color;
        }
      }
    }
  }
}
</style>
